import React from "react";
import PropTypes from "prop-types";

import "./social-share-popup.m.css";
import { CloseIcon } from "../../Svgs/close-icon";
import { RoundFacebook } from "../../Svgs/RoundedSocialShare/facebook";
import { RoundTwitter } from "../../Svgs/RoundedSocialShare/twitter";
import { RoundLinkedIn } from "../../Svgs/RoundedSocialShare/linkedin";
import { RoundWhatsapp } from "../../Svgs/RoundedSocialShare/whatsapp";

const popupSocialShareItem = (url, icon, text, index) => {
  return (
    <li data-testid={text} key={`popup-item-${index}`}>
      <a href={url} target="_blank" rel="noopener noreferrer" styleName="social-wrapper">
        {icon}
        <span styleName="social-text">{text}</span>
      </a>
    </li>
  );
};

const popupSocialShareData = ({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl }) => {
  return [
    {
      url: fbUrl,
      icon: <RoundFacebook />,
      text: "Facebook",
      bgColor: "#4e71a8",
      alt: "fb icon"
    },
    {
      url: twitterUrl,
      icon: <RoundTwitter />,
      text: "Twitter",
      bgColor: "#1db7eb",
      alt: "twitter icon"
    },
    {
      url: linkedinUrl,
      icon: <RoundLinkedIn />,
      text: "LinkedIn",
      bgColor: "#0077B5",
      alt: "linkedin icon"
    },
    {
      url: whatsappUrl,
      icon: <RoundWhatsapp />,
      text: "Whatsapp",
      bgColor: "#25d366",
      alt: "whatsapp share"
    }
  ];
};

export const SocialSharePopup = ({
  fbUrl = "",
  twitterUrl = "",
  linkedinUrl = "",
  whatsappUrl = "",
  closePopup = ""
}) => {
  const popupItemsList = popupSocialShareData({ fbUrl, twitterUrl, linkedinUrl, whatsappUrl });

  return (
    <div styleName={`share-popup-wrapper`}>
      <div styleName="share-popup">
        <div styleName="top-bar">
          <span styleName="share-text">Share via</span>
          <span styleName="close" onClick={closePopup}>
            <CloseIcon />
          </span>
        </div>
        <ul>
          {popupItemsList.map(({ url, icon, text, bgColor, alt }, index) =>
            popupSocialShareItem(url, icon, text, bgColor, alt, index)
          )}
        </ul>
      </div>
    </div>
  );
};

SocialSharePopup.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  gplusUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  grey: PropTypes.string,
  primaryColor: PropTypes.string,
  closePopup: PropTypes.bool
};
